// extracted by mini-css-extract-plugin
export default {"noDataContainer":"InstantHelpPage_noDataContainer__OWbK6","loadingContainer":"InstantHelpPage_loadingContainer__anlUK","loadingDesc":"InstantHelpPage_loadingDesc__jMBRS"};